export default __webpack_public_path__ + "static/oye-balthazaurus-scroll-bdf757251668b00f1c9341f02207828a.mp4";